<span class="c-node-search-field">
  <label
    class="form-label"
    for="searchForNodeInput"
    i18n="@@nodeSearchField-label-searchForNode"
    >Search for node</label
  >
  <input
    matInput
    id="searchForNodeInput"
    [formControl]="nodeCtrl"
    [matAutocomplete]="nodeResults"
    placeholder="Start typing node name or code"
    i18n-placeholder="@@nodeSearchField-input-placeholder-nodeNameOrCode"
    class="form-control input-bootstrap-material"
  />

  <mat-autocomplete
    #nodeResults="matAutocomplete"
    [autoActiveFirstOption]="true"
    (optionSelected)="selectNode($event)"
    class="c-node-search-field__results"
  >
    <ng-container *ngIf="searchState.isLoading === false">
      <mat-option
        *ngIf="searchState.error"
        [disabled]="true"
        class="c-node-search-field__results__unselectable qa-search-error"
        role="alert"
        i18n="@@nodeSearchField-autocomplete-option-searchError"
      >
        Sorry, we had problems running your search. Please try again.
      </mat-option>

      <mat-option
        *ngIf="searchState.searchResults?.total === 0"
        [disabled]="true"
        class="c-node-search-field__results__unselectable qa-no-results"
        role="status"
        i18n="@@nodeSearchField-autocomplete-option-noResults"
      >
        Sorry there were no results for "{{ nodeCtrl.value }}". Try to be less
        specific.
      </mat-option>

      <mat-option
        *ngIf="searchState.searchResults?.total > MAX_NODES_LIMIT"
        [disabled]="true"
        class="c-node-search-field__results__unselectable qa-too-many-results"
        role="status"
        i18n="@@nodeSearchField-autocomplete-option-tooManyResults"
      >
        There were lots of results for "{{ nodeCtrl.value }}". Try to be more
        specific.
      </mat-option>

      <mat-option
        *ngFor="
          let node of searchState.searchResults?.nodes
            | slice : 0 : MAX_NODES_LIMIT
        "
        [value]="node"
        class="c-node-search-field__results__result"
      >
        <span class="c-node-search-field__results__result__type"
          >{{ node.node_type }}:</span
        >&nbsp;
        <span class="c-node-search-field__results__result__code">{{
          node.code
        }}</span
        >&nbsp;-&nbsp;
        <span class="c-node-search-field__results__result__title">{{
          node.title
        }}</span>
      </mat-option>
    </ng-container>
  </mat-autocomplete>
</span>
